import Vue from "vue";
import moment from "moment";
import store from "@/store";
import forms from "../assets/therapyForms.json";
import {
  formatDateHoursValue,
  formatDateValue,
  formatHoursMinutesValue,
  isPastDateTimeValue
} from "../helpers/dateTime";
import {
  formatCurrencyValue,
  getAgeFromDobValue,
  validateAdultDobValue
} from "../helpers/general";

import axios from "axios";
import config from "../config/constants";

/**
 * https://bootstrap-vue.js.org/docs/components/modal/#modal-message-boxes
 * accepted props : https://bootstrap-vue.js.org/docs/components/modal/#comp-ref-b-modal
 * but in camelCase and not kebab-case
 */
const defaultModalOptions = {
  title: "",
  hideHeader: true,
  size: "md",
  buttonSize: "lg",
  okTitle: "OK",
  cancelTitle: "NO",
  footerClass: "p-2",
  hideHeaderClose: true,
  centered: true,
  contentClass: "pop-up-content"
};
/**
 *  language imports for translation files
 */
import * as en from "../assets/lang/_en";
import * as de from "../assets/lang/_de";
import { options } from "less";
const languages = {
  en: en,
  de: de
};
const languageNames = {
  en: "English",
  de: "Deutsch"
};
Vue.mixin({
  methods: {
    async logAction(action, successFunction) {
      let res = await this.api({
        path: "api/u/settings/log-action",
        action
      });
      if (successFunction) {
        successFunction;
      }
    },
    navigate(route) {
      this.$router.push(route);
      this.scrollToRef(null, true);
    },
    scrollToRef(ref, instant) {
      if (ref) {
        const el = this.$refs[ref];
        el.scrollIntoView({ behavior: "smooth" });
      } else if (instant) {
        const el = document.getElementById("LoggedIn");
        el.scrollIntoView({ behavior: "instant" });
      } else {
        const el = document.getElementById("LoggedIn");
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    friendlyTimeString(str) {
      return moment(str).fromNow();
    },
    getDateHours(str) {
      if (str) {
        return formatDateHoursValue(str, this.$store.state.lang);
      }
    },
    getMonth(str) {
      return moment(str.replace(" ", "T"))
        .locale(this.$store.state.lang)
        .format("MMM");
    },
    getDay(str) {
      return moment(str.replace(" ", "T"))
        .locale(this.$store.state.lang)
        .format("DD");
    },
    getDayString(str) {
      return moment(str.replace(" ", "T"))
        .locale(this.$store.state.lang)
        .format("ddd");
    },
    getDayStringLong(str) {
      return moment(str.replace(" ", "T"))
        .locale(this.$store.state.lang)
        .format("dddd");
    },
    getDate(str) {
      return moment(str)
        .locale(this.$store.state.lang)
        .format("ddd DD MMM Y");
    },
    getDateWithoutYear(str) {
      return moment(str)
        .locale(this.$store.state.lang)
        .format("ddd DD MMM");
    },
    getShortDate(str) {
      return moment(str)
        .locale(this.$store.state.lang)
        .format("DD MMM YY");
    },
    getHoursMinutes(str, isTwelveHour = false) {
      if (str) {
        return formatHoursMinutesValue(str, isTwelveHour);
      }
    },
    getFormatedDate(date, format) {
      return formatDateValue(date, format, this.$store.state.lang);
    },
    getChatDate(date) {
      return moment(date)
        .locale(this.$store.state.lang)
        .format("DD/MM HH:mm");
    },
    getDateLineText(appointmentStr) {
      let appointmentDate = new Date(appointmentStr).setHours(0, 0, 0, 0);
      if (navigator.userAgent.toLowerCase().indexOf("safari/")) {
        const safariDate = new Date(appointmentStr.replace(/-/g, "/"));
        appointmentDate = new Date(safariDate).setHours(0, 0, 0, 0);
      }
      const today = new Date().setHours(0, 0, 0, 0);
      const dayString = moment(appointmentDate)
        .locale(this.$store.state.lang)
        .format("dddd");
      if (appointmentDate === today) return "Today";
      if (appointmentDate === today + 86400000) return "Tomorrow";
      if (moment(appointmentDate).isoWeek() === moment().isoWeek())
        return dayString + " - This Week";
      if (moment(appointmentDate).isoWeek() === moment().isoWeek() + 1)
        return dayString + " - Next Week";
      if (moment(appointmentDate).isoWeek() === 1 && moment().isoWeek() === 52)
        return dayString + " - Next Week";
      return moment(appointmentDate).fromNow();
    },
    getFriendlyDateText(appointmentStr) {
      let appointmentDate = new Date(appointmentStr).setHours(0, 0, 0, 0);
      if (navigator.userAgent.toLowerCase().indexOf("safari/")) {
        const safariDate = new Date(appointmentStr.replace(/-/g, "/"));
        appointmentDate = new Date(safariDate).setHours(0, 0, 0, 0);
      }
      const today = new Date().setHours(0, 0, 0, 0);
      const dayString = moment(appointmentDate)
        .locale(this.$store.state.lang)
        .format("Do MMMM");
      if (appointmentDate === today) return "Today";
      if (appointmentDate === today + 86400000) return "Tomorrow";
      if (moment(appointmentDate).isoWeek() === moment().isoWeek())
        return dayString;
      if (moment(appointmentDate).isoWeek() === moment().isoWeek() + 1)
        return dayString;
      if (moment(appointmentDate).isoWeek() === 1 && moment().isoWeek() === 52)
        return dayString;
      return moment(appointmentDate).fromNow();
    },
    getTheme() {
      return "theme-" + this.$store.getters.skin;
    },
    isPast(str) {
      if (str) {
        return isPastDateTimeValue(str);
      }
    },
    showMsgModal(msg = "something", options = defaultModalOptions) {
      const skin = this.$store.getters.skin;
      options.modalClass = "theme-" + skin;
      return this.$bvModal.msgBoxOk(msg, options);
    },
    showConfirmModal(msg = "something", options = defaultModalOptions) {
      const skin = this.$store.getters.skin;
      options.modalClass = "theme-" + skin;
      return this.$bvModal.msgBoxConfirm(msg, options);
    },
    showProfileQuestionnaireModal(user, email, client_name) {
      const content = this.$createElement(ProfileQuestionnaireModal, {
        props: { user: user, email: email, client_name: client_name }
      });
      const skin = this.$store.getters.skin;
      let opts = {
        title: "Complete your profile to start your journey!",
        hideHeader: true,
        hideFooter: true,
        hideOk: true,
        modalClass: "questionnaire-modal theme-" + skin,
        headerClass: "questionnaire-modal-header",
        size: "lg",
        buttonSize: "sm",
        centered: true,
        contentClass: "questionnaire-modal-content",
        id: "profile-questionnaire-modal"
      };
      return this.$bvModal.msgBoxOk(content, opts);
    },
    currencyString(cents = 0, curr = "eur") {
      return formatCurrencyValue(cents, curr);
    },
    async api(params) {
      if (!params.hasOwnProperty("user_id")) {
        params.user_id = this.$store.getters.user_id;
      }
      const path = params.path;
      let payload = params;
      delete payload.path;
      let res = await axios.post(
        config.api_env + "/application/" + path,
        payload,
        config.options
      );
      if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login").catch(err => {});
        return false;
      } else {
        return res.data;
      }
    },
    isLayaWellbeing() {
      console.log(window.location.host);
      return window.location.host.search("laya-wellbeing") > -1;
    },
    isConnectedMentalHealth() {
      return false;
    },
    isOver18(dateOfBirth) {
      let dobMoment = moment(dateOfBirth, "DD-MM-YYYY", true);
      if (!dobMoment.isValid()) {
        dobMoment = moment(dateOfBirth, "D-M-YYYY", true);
      }
      if (!dobMoment.isValid()) {
        return false;
      }
      const age = moment().diff(dobMoment, "years");
      return age >= 18;
    },
    connectedMentalHealthType() {
      if (this.$store.getters.user.therapy.area)
        return this.$store.getters.user.therapy.area.toLowerCase();
      if (!this.isConnectedMentalHealth()) return null;
      const parts = window.location.host.split(".");
      return parts[0];
    },
    genRandonString(length) {
      var chars =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
      var charLength = chars.length;
      var result = "";
      for (var i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * charLength));
      }
      return result;
    },
    getCurrencyPriceString(currency, amount, full = false) {
      let am = amount / 100;
      let opts = {
        style: "currency",
        currency: currency.toUpperCase(),
        maximumFractionDigits: full ? 2 : 0
      };
      let value = am.toLocaleString("en-IE", opts);
      if (value.slice(-3) === ".00") {
        value = value.slice(0, value.length - 3);
      }
      return value;
    },
    addCommasToInteger(int) {
      let number = Number.parseInt(int);
      if (isNaN(number)) return false;
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    convertMilesToMeters(miles) {
      return Math.floor(miles * 1609.344);
    },
    convertMetersToMiles(meters) {
      return Math.round(meters * 0.000621371 * 100) / 100;
    },
    determinePercentageOfFormComplete(formName, answers) {
      const form = forms[formName];
      let questionCount = 0;
      let answerCount = 0;
      if (formName.substring(0, 6) === "intake") {
        form.form_groups.forEach(group => {
          group.questions.forEach(q => {
            if (q.required) {
              questionCount++;
              if (answers.hasOwnProperty(q.id)) {
                if (q.type === "phone") {
                  if (answers[q.id].phone) answerCount++;
                } else {
                  if (answers[q.id]) answerCount++;
                }
              }
            }
          });
        });
      } else {
        if (form) {
          form.questionnaire.forEach(q => {
            questionCount++;
            const i = answers.findIndex(a => a.id === q.id);
            if (i !== -1 && answers[i].answer !== null) answerCount++;
          });
        } else {
          console.log(formName);
        }
      }
      return answerCount / questionCount;
    },
    validateEmailAddress(email) {
      return /^[\w.+-]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email);
    },
    m(eventName, payload) {
      //console.log({"event": eventName, path: this.$route.path ,...payload});
      //window._mtm.push({"event": eventName, path: this.$route.path ,...payload});
    },
    getTherapyFromSlug(slug) {
      let result = {};
      switch (slug) {
        case "therapy_child":
        case "psychology_child":
          result.age_group = "Child";
          result.area = "Therapy";
          break;
        case "autism_child":
        case "adhd_child":
        case "adhd_and_autism_child":
          result.age_group = "Child";
          result.area = "Neurodiversity";
          break;
        case "therapy_adult":
        case "psychology_adult":
          result.age_group = "Adult";
          result.area = "Therapy";
          break;
        case "autism_adult":
        case "adhd_adult":
        case "adhd_and_autism_adult":
          result.age_group = "Adult";
          result.area = "Neurodiversity";
          break;
        default:
          result.age_group = "Adult";
          result.area = "Therapy";
      }
      return result;
    },
    getTherapyDetailsFromSlug(slug) {
      switch (slug) {
        case "therapy_child":
          return {
            label: "Child & Adolescent Psychotherapy",
            price: "8500",
            area: "Therapy",
            age_group: "Child"
          };
        case "psychology_child":
          return {
            label: "Child & Adolescent Psychology",
            price: "8500",
            area: "Therapy",
            age_group: "Child"
          };
        case "autism_child":
          return {
            label: "Online Autism Assessment - Child and Adolescent",
            price: "200000",
            area: "Neurodiversity",
            age_group: "Child"
          };
        case "adhd_child":
          return {
            label: "Online ADHD Assessment - Child and Adolescent",
            price: "200000",
            area: "Neurodiversity",
            age_group: "Child"
          };
        case "adhd_and_autism_child":
          return {
            label: "Online ADHD & Autism Assessment - Child & Adolescent",
            price: "200000",
            area: "Neurodiversity",
            age_group: "Child"
          };
        case "therapy_adult":
          return {
            label: "Adult Digital Psychotherapy",
            price: "8500",
            area: "Therapy",
            age_group: "Adult"
          };
        case "psychology_adult":
          return {
            label: "Adult Digital Psychology",
            price: "8500",
            area: "Therapy",
            age_group: "Adult"
          };
        case "autism_adult":
          return {
            label: "Online Autism Assessment - Adult",
            price: "200000",
            area: "Neurodiversity",
            age_group: "Adult"
          };
        case "adhd_adult":
          return {
            label: "Online ADHD Assessment - Adult",
            price: "200000",
            area: "Neurodiversity",
            age_group: "Adult"
          };
        case "adhd_and_autism_adult":
          return {
            label: "Online ADHD & Autism Assessment - Adult",
            price: "200000",
            area: "Neurodiversity",
            age_group: "Adult"
          };
        case "cmh_assessment":
          return {
            label: "Specialist Assessment",
            price: "0",
            area: "Therapy",
            age_group: "Adult"
          };
      }
    },
    cmhAdditionalFormNames(age_group, age = 0) {
      const formNames =
        age_group === "Adult"
          ? ["asrs_neurodiversity_adult", "aq-10_neurodiversity_adult"]
          : [
              "rcads_neurodiversity_child_p",
              "snap-iv_neurodiversity_child_p",
              "rcads_neurodiversity_child_c",
              "yp-core_neurodiversity_child_c"
            ];
      if (age_group === "Child") {
        if (age <= 12) {
          formNames.push("aq10-4-to-11_neurodiversity_child_p");
        } else if (age < 16) {
          formNames.push("aq10-12-to-15_neurodiversity_child_p");
        } else {
          formNames.push("aq10-16+_neurodiversity_child_p");
        }
      }
      return formNames;
    },
    isAccessibilitySite() {
      const parsedUrl = new URL(window.location.href);
      let hostnameParts = parsedUrl.hostname.split(".");
      return hostnameParts[0] === "accessibility";
    },
    validatePhoneNumber(phoneNo) {
      const phonePattern = /^\+?[0-9]{8,15}$/;
      return phonePattern.test(phoneNo);
    },
    getAgeFromDob(str) {
      return getAgeFromDobValue(str);
    },
    validateChildDob(dob) {
      if (!dob) {
        return false;
      } else {
        const age = this.getAgeFromDob(dob);
        return age >= 6 && age <= 16;
      }
    },
    validateAdultDob(dob) {
      return validateAdultDobValue(dob);
    },
    isValidField(value) {
      return (
        value !== null &&
        (typeof value === "number" ||
          (typeof value === "string" && value.trim().length > 1))
      );
    },
    validateDmhAnswers(answers) {
      if (answers === null || typeof answers !== "object") return null;

      const result = {};
      const nonMandatoryFields = ["gp_email"];

      for (const [key, value] of Object.entries(answers)) {
        if (nonMandatoryFields.includes(key)) {
          result[key] =
            value.length === 0 ? true : this.validateEmailAddress(value);
        } else if (key.includes("email")) {
          result[key] = this.validateEmailAddress(value);
        } else if (key.includes("phone_number")) {
          result[key] = this.validatePhoneNumber(value);
        } else if (key.includes("child_dob")) {
          result[key] = this.validateChildDob(value);
        } else if (key.includes("dob")) {
          result[key] = this.validateAdultDob(value);
        } else {
          result[key] = this.isValidField(value);
        }
      }
      return result;
    },
    detectMobileOS() {
      const ua = navigator.userAgent || navigator.vendor;

      if (/android/i.test(ua)) return "android";
      if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
      if (/Mac OS/.test(ua)) return "mac";
      // iPadOS (reports as Mac)
      if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) {
        return "ios";
      }
      return "other";
    }
  },
  computed: {
    allLanguages() {
      return languageNames;
    },
    getText() {
      let lang = store.state.lang;
      if (lang !== "en" || lang !== "de") lang = "en";
      return languages[lang].default;
    }
  }
});
